<script setup lang="ts">
const props = defineProps<{
  slide: any;
}>();

const { slide } = props;
</script>
<template>
  <div class="inner-wrap">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
      <div
        v-if="slide.sliderImage?.media?.url"
        class="left w-full md:w-[350px] lg:w-[488px] mb-6 md:mb-0"
      >
        <div class="wrap-img">
          <figure>
            <NuxtImg
              ref="imageElement"
              loading="lazy"
              format="webp"
              :height="slide.sliderImage.media.metaData.height"
              :width="slide.sliderImage.media.metaData.width"
              :src="slide.sliderImage?.media.url"
              :alt="slide.sliderHeadlineText || ''"
              class="w-full h-auto rounded-lg"
              data-testid="inspire-img"
            />
          </figure>
        </div>
      </div>
      <div class="right py-0 lg:py-12 lg:pl-8 xl:pl-2 md:w-[350px] lg:w-[590px]">
        <div class="description">
          <h5
            v-if="slide.sliderHeadlineText"
            class="font-bold leading-normal text-lg md:text-2xl mb-4"
          >
            {{ slide.sliderHeadlineText }}
          </h5>
          <div
            v-if="slide.sliderText"
            class="text-sm font-normal text-dark-bg leading-relaxed mb-8"
            v-html="slide.sliderText"
          ></div>
          <SharedButton
            v-if="slide.button"
            :button="slide.button"
            class="btn-default btn-black-bg btn-default px-11"
          >
          </SharedButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
